// extracted by mini-css-extract-plugin
export default {"achievements":"achievements-profile_achievements__oVqRP"};